import { ApiBase } from '../ApiBase';
import { getCurrentEnvironment } from '@fourthwall/env';
// NOTE: we can't use Axios to make SSE requests, because Axios doesn't support streaming the response.body.getReader() is not available in Axios.
// Axios returns the entire response at once, which prevents streaming. We need to use fetch() to make SSE requests.
class AIKitApiClientModel extends ApiBase {
    constructor() {
        // Use root URL since we'll construct full URLs ourselves
        super('/');
        // NOTE: this is a temporary solution to get the base URL. We should use env variables for the base URL in the future.
        // TODO: use env variables for the base URL
        const baseUrl = getCurrentEnvironment() === 'development'
            ? 'http://localhost:8000'
            : 'https://fw-chatbot-353003853979.us-west1.run.app';
        this.omnisearchUrl = `${baseUrl}/api/omnisearch`;
        this.chatUrl = `${baseUrl}/api/chat`;
    }
    getAuthToken() {
        const authHeader = this.instance.defaults.headers.common.Authorization;
        if (authHeader && authHeader.startsWith('Bearer ')) {
            return authHeader.substring(7);
        }
        return undefined;
    }
    getAuthorizationHeader() {
        return this.instance.defaults.headers.common.Authorization;
    }
    getOmnisearchUrl() {
        return this.omnisearchUrl;
    }
    getChatUrl() {
        return this.chatUrl;
    }
}
export const AIKitApiClient = new AIKitApiClientModel();
